import React from 'react';

const B2B_URL = 'https://philippines-orpin.vercel.app/';

const B2B = () => (
  <iframe
    src={B2B_URL}
    title="Comparison Guru B2B"
    className="w-full block border-0"
    style={{ height: 'calc(100vh - 120px)' }}
    allow="clipboard-read; clipboard-write"
  />
);

export default B2B;
